// extracted by mini-css-extract-plugin
export var procedure = "procedure-module--procedure--1AiEa";
export var pricelistItem = "procedure-module--pricelistItem--gEgWr";
export var procedureTitle = "procedure-module--procedureTitle--21Tl0";
export var price = "procedure-module--price--1wMO6";